import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import WipeDataPic from "../../../../assets/images/wipe-data.png";
import { useDispatch, useSelector } from "react-redux";
import { wipeDeviceData } from "../../AxiosRtk/DeviceDetail";
import { setShowMessage } from "../../AxiosRtk/successMessage";

const WipeDeviceData = ({ showModal, closeModal, getLangTranslation }) => {
  const dispatch = useDispatch();
  const modalRef = useRef();
  const { selectedDeviceData } = useSelector(({ dashboard }) => dashboard);

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  const handleWipeDeviceData = async () => {
    try {
      const payload = {
        case: 5,
        deviceId: selectedDeviceData?.ID,
      };
      const { data } = await wipeDeviceData(payload);
      if (data) {
        closeModal();

        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">{getLangTranslation("CHILD_NAV_WIPE_DEVICE_DATA", "Wipe device data")}</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <img className="d-block mx-auto mt-6" src={WipeDataPic} alt="" />
            <h6 className="mt-6 mb-9 text-center text-blue-900">
              {
                getLangTranslation("DEVICE_DETAIL_WIPE_DATA_DIALOG_TITLE", "Do you really want to erase all data from your child device?")
              }
            </h6>
            <div className="grid gap-3">
              <button
                className="btn btn-outline-primary g-col-6"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
                <span className="btn-upper-case">{getLangTranslation("CANCEL", "Cancel")}</span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                onClick={handleWipeDeviceData}
              >
                <span className="btn-upper-case">{getLangTranslation("SELECT_CHILD_YES", "Yes")}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WipeDeviceData;
